import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "index-sections" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-circle-o-left",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_3 = { class: "article-header" }
const _hoisted_4 = { class: "article-heading" }
const _hoisted_5 = { class: "article-subheading" }
const _hoisted_6 = { class: "article-body" }
const _hoisted_7 = { class: "article-img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "article-writeup" }
const _hoisted_10 = { class: "article-title" }
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/articles",
      class: "nav-link"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" Back to the list of articles ")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.articleData?.title), 1),
      _createElementVNode("small", _hoisted_5, "Published: " + _toDisplayString(_ctx.articleData?.published), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          src: _ctx.thumbnailUrl,
          alt: "Featured Article Thumbnail",
          loading: "lazy"
        }, null, 8, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.articleData?.subTitle), 1),
        _createElementVNode("p", {
          innerHTML: _ctx.articleData?.body,
          class: "article-description"
        }, null, 8, _hoisted_11)
      ])
    ])
  ]))
}